import {TableRow} from './table-row.model';
import {Base} from './base.model';
import {TranslateService} from '@ngx-translate/core';

export class Table {

  constructor(public keys: string[], public rows: TableRow[]) {}

  public static buildBaseTable(keys: string[], items: Base[], translate?: TranslateService) {
    const rows  = [];
    items.forEach( item => {
      const tableRow = item.toTableRow(translate);
      if (tableRow) {
        rows.push(tableRow);
      }
    });
    return new Table(keys, rows);
  }
}
